import styled from 'styled-components';
import { ReactComponent as ArrowDown } from '../assets/images/arrow-down.svg';
import { ReactComponent as SearchIcon } from '../assets/images/search.svg';

const SelectWrapper = styled.div``;

export const DisabledSelectStyled = {
  control: (provided, state) => ({
    ...provided,
    opacity: '0.3'
  })
};

export const SelectStyled = {
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    marginLeft: '8px'
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 })
};

export const themeOverride = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#7a86a9',
    neutral20: '#eaeeef',
    neutral30: '#7a86a9'
  }
});

export const DropdownIndicator = ({ search }) =>
  search ? <SearchIcon className="mr-1" /> : <ArrowDown className="mr-1" />;

export const IndicatorSeparator = () => <></>;

export const LoadingIndicator = () => (
  <div className="select-loading-indicator">
    <div className="spinner-border" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);
export default SelectWrapper;
